import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button
} from '@material-ui/core';

import firebase from '../../Firebase';
import 'firebase/database';
import { SIREN_CONFIG, CONFIG_SETTINGS } from 'config.js';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";


const COLUMN_WIDTH = {
  ROOM : '45%',
  TIME: '30%',
  ACTION: '20%'
}


const DeviceStatusTable = props => {
  const { className, users, DeviceRowsPerPage, ...rest } = props;

  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [rowsPerPage, setRowsPerPage] = useState(DeviceRowsPerPage);
  const [page, setPage] = useState(0);

  const [listData, setListData] = useState([]);
  const firebaseRootRef = useSelector((store) => store.envSettings.firebaseRootRef)
  const facility_id = useSelector((store) => store.user.facility_id);

  const searchData = () => {
    // ?baseDate=2021-07-29 18:22:10
    fetch(`${SIREN_CONFIG.HOSTNAME}/device/onErrorDeviceList?facility_id=${facility_id}`)
    .then(res => res.json())
    .then(responseData => {
      var list = [];

      responseData.resultData.forEach( doc => {

        list.push( {
          "rowId": doc.rowId,
          "deviceId": doc.deviceId,
          "roomName": doc.roomName,
          "installed_pos_detail": doc.installed_pos_detail,
          "errorTime": doc.errorTime,
          "action_taken": doc.action_taken
        });
      });

      setListData(list);
      // console.log("deviceStatus value change: ", list);
    });
  }


  useEffect( () => {

    if (firebaseRootRef == null || firebaseRootRef.length == 0) return;

    var dbRef = firebase.database().ref('/dashboard/'+ firebaseRootRef ).child("deviceStatus");
    dbRef.on('value', (snapshot) => {
      //realtime DB값이 변경되면, error상태 디바이스 목록을 갱신한다.
      searchData();
    });

    return () => {};
  }, []);


  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
    localStorage.setItem(CONFIG_SETTINGS.DeviceRowsPerPage, event.target.value);
  };


  const startRow = (page*rowsPerPage);


  return (

    <Card className={clsx(classes.root, className)} {...rest} >

      <CardHeader
        title={formatMessage({id:'device_check_table_title'})}
        titleTypographyProps={{ align: "center", variant:'h4' }}
        subheader={formatMessage({id:'device_check_table_subheader'})}
        subheaderTypographyProps={{align: "right", variant: "caption"}}
      />

      <Divider />

      <CardContent className={classes.content}>
        <PerfectScrollbar style={{ height: CONFIG_SETTINGS.TABLE_HEIGHT }}>
          <div className={classes.inner}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell width={COLUMN_WIDTH.ROOM} align="center"><FormattedMessage id="device_check_table_room" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.TIME} align="center"><FormattedMessage id="device_check_table_occurTime" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.ACTION} align="center"><FormattedMessage id="device_check_table_action" /></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {listData.slice(0+startRow, rowsPerPage+(page*rowsPerPage)).map(module => (

                  <TableRow
                    className={classes.tableRow}
                    key={module.rowId}
                    component={RouterLink} to={`/deviceError/update/${module.rowId}`}
                    >

                    {/* <TableCell width={COLUMN_WIDTH.DEVICE_ID} align="center">
                        <Typography variant="body2">{module.deviceId}</Typography>
                    </TableCell> */}
                    {/* <TableCell width={COLUMN_WIDTH.ROOM} align="center">
                      <Typography variant="body1">{module.roomName} - {module.installed_pos_detail}</Typography>
                    </TableCell> */}
                    <TableCell width={COLUMN_WIDTH.ROOM} align="left">
                      <Typography variant="body1">{module.roomName}&nbsp;<Typography variant="caption">{module.installed_pos_detail}</Typography></Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.TIME} align="center">
                      <Typography variant="caption">
                      {module.errorTime}
                      </Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.ACTION} align="center">
                      {
                        module.action_taken ?
                        <Typography variant="body2">{module.action_taken}</Typography>
                        : (
                          <Button
                          color="primary"
                          variant="contained"
                          size="small"
                          component={RouterLink} to={`/deviceError/update/${module.rowId}`}
                        >
                          <FormattedMessage id="device_check_table_act" />
                        </Button>
                        )
                      }
                    </TableCell>
                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <Divider />

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10]}
        />
      </CardActions>
    </Card>
  );
};

DeviceStatusTable.propTypes = {
  className: PropTypes.string,
};


export default DeviceStatusTable;


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // marginLeft: theme.spacing(1)
  },
  queryField: {
    // width: 300
    flexBasis: 260,
    marginRight:20,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
}));
